






import { Component, Vue } from "vue-property-decorator";
import GiziSupervisiList from "@/components/gizi/supervisi/GiziSupervisiList.vue";

@Component({
  components: { GiziSupervisiList }
})
export default class GiziSupervisiPage extends Vue {}
